// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Urbanist", sans-serif !important;
}

/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.preferences_dashboard__tSBy1 {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px 30px 80px 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  overflow-y: auto;
}

.preferences_dashboardContain__bDkZ5 {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.preferences_bodythemedark__np6Ve .preferences_dashboardContain__bDkZ5,
.preferences_bodythemedark__np6Ve .preferences_dashboard__tSBy1,
.preferences_bodythemedark__np6Ve .preferences_cont2__depn9 {
  background-Color: #0f1824;
}

.preferences_top_header__l7aPN .preferences_top_header_inner__Dth2I {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.preferences_cont2__depn9 {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.preferences_subLink__khKDa svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.preferences_footer__r04q2 {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.preferences_bodythemelight__tHR-R {
  background-color: #fff;
  padding-top: 90px;
}

.preferences_bodythemedark__np6Ve {
  background-color: #132337;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.preferences_headerthemelight__Hco8q {
  background-color: #fff;
}

.preferences_headerthemedark__EFH3X {
  background-color: #132337;
}

.preferences_top_header__l7aPN {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 1;
}

/* 
LEFT MENU THEME CHANGE
*/
.preferences_menuthemelight__FTSff {
  background-color: #fff;
}

.preferences_menuthemedark__Qijid {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.preferences_menulinklight__3Lqd7 span {
  color: #666666 !important;
}

.preferences_menulinklight__3Lqd7 a {
  color: #CBCBCB !important;
}

.preferences_menulinklight__3Lqd7:hover span, .preferences_menulinklight__3Lqd7:hover a {
  color: #fff !important;
}

.preferences_menulinkdarkSelected__zN0Tf {
  background-color: #1c2e45;
  color: #fff;
}

.preferences_menuthemelight__FTSff .preferences_menulinklightSelected__reWhp {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #205440;
}

.preferences_menulinkdark__YRAx\\+ {
  color: #60677e !important;
}

.preferences_menulinklight__3Lqd7:hover {
  color: #fff !important;
  background-color: #205440;
}

.preferences_menulinkdark__YRAx\\+:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.preferences_headinglight__x4dYo {
  color: #60677e;
}

.preferences_headingdark__RPbE2 {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.preferences_searchboxlight__ijq4Y {
  background-color: #fff;
  border: none;
}

.preferences_searchboxdark__sEMKE {
  background-color: #132337;
  color: #fff;
  border: none;
}

.preferences_searchboxdark__sEMKE::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.preferences_tableheadlight__XPJQ4 {
  background-color: #205440;
  border-radius: 5px 5px 0px 0px;
}

.preferences_tableheadlight__XPJQ4 th {
  color: #fff;
}

thead .preferences_tableheadlight__XPJQ4 th:first-child,
thead .preferences_tableheaddark__\\+2rDh th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .preferences_tableheadlight__XPJQ4 th:last-child,
thead .preferences_tableheaddark__\\+2rDh th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.preferences_table__BP\\+02.preferences_table-borderless__H7cIg {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.preferences_tableheaddark__\\+2rDh {
  background-color: #1e1e2d;
  color: #fff;
}

.preferences_table-borderless__H7cIg tr:nth-child(even) {
  background-color: #F9FAFB;
}

.preferences_table-borderless__H7cIg .preferences_left-section__6ls-q {
  padding-top: 10px;
}

.preferences_tablebodylight__FAGxy td,
.preferences_tablebodydark__JAnvR td {
  padding: 1rem 1rem !important;
}

.preferences_tablebodylight__FAGxy {
  background-color: #fff;
}
.preferences_tablebodylight__FAGxy:hover {
  background-color: #ddecf9;
  cursor: pointer;
}

.preferences_tablebodydark__JAnvR {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.preferences_tablebodydark__JAnvR:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: pointer;
}

/* 
PAGINATION THEME COLOR
*/
.preferences_paginationlight__5Hjsu {
  color: #60677e !important;
  font-size: 13px !important;
}

.preferences_paginationdark__lu5oV {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.preferences_formthemelight__q3vTO {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.preferences_formthemedark__I1pqo {
  background-color: #1e1e2d;
  color: #60677e !important;
  font-size: 14px;
}
.preferences_formthemedark__I1pqo ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.preferences_viewformlight__4yKMt {
  background-color: #f3f6f9;
}

.preferences_permissionboxlight__6lfep {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.preferences_permissionboxdark__gGSCa {
  background-color: #151521;
  border: solid 1px #242434;
}

.preferences_errormsgclr__zz3-Z {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.preferences_graphclrlight__IKRVf {
  background-color: #fff;
}

.preferences_graphclrdark__kBaaI {
  background-color: #1e1e2d;
}

/* 
Counter theme
*/
#preferences_card1bglight__tjy3Q {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#preferences_card1bglight__tjy3Q:hover {
  background: #f7fffc;
}

#preferences_card1bgdark__bXNWZ {
  background: #392f28;
}

#preferences_card1bgdark__bXNWZ:hover {
  background: #f7fffc;
}

#preferences_card2bglight__5jhHk {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#preferences_card2bglight__5jhHk:hover {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #f7fffc;
}

#preferences_card2bgdark__jXDR9 {
  background: #1c3238;
}

#preferences_card3bglight__33Qkg {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#preferences_card3bglight__33Qkg:hover {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #f7fffc;
}

#preferences_card3bgdark__AryWb {
  background: #3a2434;
}

#preferences_card4bglight__JHMsk {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#preferences_card4bglight__JHMsk:hover {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #f7fffc;
}

#preferences_card4bgdark__eweA0 {
  background: #2f264f;
}

#preferences_card1bgdark__bXNWZ a, #preferences_card1bgdark__bXNWZ p,
#preferences_card2bgdark__jXDR9 a, #preferences_card2bgdark__jXDR9 p,
#preferences_card3bgdark__AryWb a, #preferences_card3bgdark__AryWb p,
#preferences_card4bgdark__eweA0 a, #preferences_card4bgdark__eweA0 p {
  color: #fff;
}

/* 
Action button theme
*/
.preferences_actionbtnlight__HDnp3 {
  color: rgba(70, 71, 91, 0.8705882353);
}

.preferences_actionbtndark__Ao-sf {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.preferences_profiledropdownlight__-DJRK {
  background-color: #fff;
}

.preferences_profiledropdowndark__Gx3xT {
  background-color: #151521;
}

.preferences_settingsection__w4Ex8 #preferences_addform__oGG7x.preferences_formthemedark__I1pqo .preferences_savebtn__NIyFf {
  background-color: #0a2574;
  color: #fff;
}

#preferences_addform__oGG7x.preferences_formthemedark__I1pqo .preferences_savebtn__NIyFf {
  background-color: #0a2574;
  color: #fff;
}

.preferences_profile_conatiner__4LKOk {
  border-radius: 5px !important;
}

.preferences_bodythemedark__np6Ve .preferences_ag-theme-alpine__F37Wi .preferences_ag-row__BQWoB {
  background: #000 !important;
}

.preferences_bodythemedark__np6Ve .preferences_formbtn__MYlvp {
  background-color: #0a2574;
}

.preferences_bodythemedark__np6Ve .preferences_resetbtn__GAT1d {
  color: #fff;
  background-color: transparent;
  border: solid 1px #0a2574;
}

.preferences_bodythemedark__np6Ve .preferences_resetbtn__GAT1d:hover {
  background-color: #0a2574;
}

.preferences_headingdark__RPbE2 span {
  background-color: #132337;
}

.preferences_resetbtn__GAT1d {
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px #205440;
  color: #205440;
  min-width: 113px;
}

.preferences_resetbtn__GAT1d:hover,
.preferences_resetbtn__GAT1d:active,
.preferences_resetbtn__GAT1d:focus {
  background-color: #205440;
  color: #fff;
}

.preferences_addBtn__DeCdD {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.preferences_addBtn__DeCdD svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.preferences_addBtn__DeCdD:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.preferences_cust_addBtn__7UZXY.preferences_addBtn__DeCdD svg {
  top: 2px;
}

.preferences_deleteBtn__9qyD7 {
  min-width: auto;
  padding: 10px 0;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.preferences_deleteBtn__9qyD7 {
  min-width: auto !important;
  height: 50px !important;
  background-color: #205440 !important;
  color: #fff !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border: none !important;
  padding: 0.375rem 1rem !important;
}

.preferences_deleteBtn__9qyD7:active, .preferences_deleteBtn__9qyD7:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.preferences_deleteBtn__9qyD7 svg {
  position: relative;
  top: -2px;
}

.preferences_deleteBtn__9qyD7:hover,
.preferences_deleteBtn__9qyD7:active,
.preferences_deleteBtn__9qyD7:focus {
  background-color: #205440 !important;
  color: #fff;
  border: none;
}

.preferences_confirmBtn__JDTye {
  background-color: #205440;
}

.preferences_confirmBtn__JDTye:hover,
.preferences_confirmBtn__JDTye:active,
.preferences_confirmBtn__JDTye:focus {
  background-color: #205440;
}

.preferences_confirmBtn__JDTye svg {
  top: 0;
}

.preferences_back_dlt__S1L7r {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.preferences_delPopContainer__nLae- .preferences_modal-body__SNFZQ {
  padding: 25px;
  text-align: center;
}

.preferences_delPopContainer__nLae- .preferences_delet_icon__Gec\\+n {
  margin-bottom: 11px;
}

.preferences_delPopContainer__nLae- p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
}

.preferences_arrowback__drSNZ svg {
  fill: #000;
}

.preferences_bodythemedark__np6Ve .preferences_arrowback__drSNZ {
  background-color: #0a2574;
  color: #fff;
}

.preferences_bodythemedark__np6Ve .preferences_arrowback__drSNZ svg {
  fill: #fff;
}

.preferences_bodythemedark__np6Ve .preferences_drpdwn_btn__sEdF1 {
  background-color: #132337;
}

.preferences_bodythemedark__np6Ve .preferences_empname__-jOgz {
  color: #60677e !important;
}

.preferences_bodythemedark__np6Ve .preferences_navitemli__fGQU8 a {
  background-color: transparent;
  border: solid 1px #0a2574;
  color: #fff;
}

.preferences_bodythemedark__np6Ve .preferences_tabnavli__H0hVT a.preferences_settingsgeneral__D3n6U,
.preferences_bodythemedark__np6Ve .preferences_tabnavli__H0hVT a.preferences_settingslinks__1rthO:hover {
  background-color: #0a2574;
  color: #fff;
}

.preferences_bodythemedark__np6Ve .preferences_tabnavli__H0hVT a.preferences_settingslinks__1rthO {
  background-color: transparent;
  border: solid 1px #0a2574;
  color: #fff;
}

@media only screen and (max-width: 1200px) {
  .preferences_tableheadlight__XPJQ4 th {
    min-width: 100px;
  }
}
@media only screen and (max-width: 1024px) {
  .preferences_dashboard__tSBy1 {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 998px) {
  #preferences_dashboardcont2__lSw8P {
    height: auto !important;
  }
}
@media only screen and (max-width: 767px) {
  .preferences_sectionright__lDN5V {
    float: unset !important;
  }
  .preferences_dashboard__tSBy1 {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .preferences_cont2__depn9 {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 20px 10px !important;
  }
  .preferences_bodythemelight__tHR-R, .preferences_bodythemedark__np6Ve {
    padding-top: 165px;
  }
}
@media (min-width: 576px) {
  .preferences_exer_modal_contain__lNxkM .preferences_modal-dialog__AU0YP {
    max-width: 1055px;
  }
  .preferences_delPopContainer__nLae- .preferences_modal-dialog__AU0YP {
    max-width: 350px;
  }
}
#preferences_addform__oGG7x {
  margin-top: 30px;
  padding: 30px;
  border-radius: 10px;
}
#preferences_addform__oGG7x #preferences_addheading__v4xT9 {
  font-size: 16px;
  margin-bottom: 20px;
}
#preferences_addform__oGG7x .preferences_selectdate__Qx0TG {
  padding: 5px;
  border: 1px solid #ced4da;
  border-radius: 5px;
}
#preferences_addform__oGG7x .preferences_savebtn__NIyFf {
  border: none;
  border-radius: 5px;
  background-color: #205440;
  padding: 10px;
  color: #fff;
  font-size: 14px;
  margin-top: 20px;
}
#preferences_addform__oGG7x .preferences_savebtn__NIyFf:hover {
  background-color: rgba(37, 105, 109, 0.864);
}

@media only screen and (max-width: 767px) {
  .preferences_selectdate__Qx0TG {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/pages/settings/preferences.module.scss"],"names":[],"mappings":"AAEA;EACE,8CAAA;ACAF;;ADGA;;EAAA;AAqCA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,4BAAA;EACA,kBAAA;EACA,2BAAA;EACA,yBAAA;EACA,gBAAA;AC3DF;;AD6DA;EACE,yBAAA;EACA,yBAlFO;EAmFP,kBAAA;AC1DF;;AD4DA;;;EAGE,yBAjEoB;ACQtB;;AD2DA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACxDF;;AD2DA;;CAAA;AAIA;EACE,wBAtCU;EAuCV,UAtCS;EAuCT,kBAAA;EACA,aA9CiB;EA+CjB,kBAAA;EACA,mBA1GO;EA2GP;;;GAAA;ACtDF;;AD4DA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ACzDF;;AD8DA;EACE,YAAA;AC3DF;;AD8DA;EACE,sBA7FY;ACkCd;;AD8DA;;CAAA;AAGA;EACE,sBApGY;EAqGZ,iBAAA;AC3DF;;AD6DA;EACE,yBAnHgB;EAoHhB,iBAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBAhHY;ACsDd;;AD6DA;EACE,yBA/HgB;ACqElB;;AD4DA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;ACzDF;;AD4DA;;CAAA;AAGA;EACE,sBAnIY;AC0Ed;;AD2DA;EACE,yBAjJgB;ACyFlB;;AD2DA;;CAAA;AAGA;EACE,yBAAA;ACxDF;;AD2DA;EACE,yBAAA;ACxDF;;AD2DA;EACE,sBAAA;ACxDF;;AD2DA;EACE,yBAlKsB;EAmKtB,WA1JY;ACkGd;;AD0DA;EACE,sCAAA;EACA,sBAAA;EACA,yBA/Lc;ACwIhB;;AD0DA;EACE,yBAAA;ACvDF;;AD0DA;EACE,sBAAA;EACA,yBAxMc;ACiJhB;;AD0DA;EACE,yBArLsB;EAsLtB,WA7KY;ACsHd;;AD0DA;;CAAA;AAGA;EACE,cAjLe;AC0HjB;;AD0DA;EACE,cArLe;AC8HjB;;AD0DA;;CAAA;AAGA;EACE,sBA/LY;EAgMZ,YAAA;ACvDF;;AD0DA;EACE,yBA/MgB;EAgNhB,WArMY;EAsMZ,YAAA;ACvDF;;ADyDA;EACE,cAtMe;ACgJjB;;ADyDA;;CAAA;AAGA;EACE,yBAhPc;EAiPd,8BAAA;ACtDF;;ADwDA;EACE,WApNY;AC+Jd;;ADuDA;;EAEE,0BAAA;ACpDF;;ADsDA;;EAEE,0BAAA;ACnDF;;ADqDA;EACE,kBAAA;AClDF;;ADoDA;EACE,kBAAA;ACjDF;;ADmDA;EACE,oCAAA;EACA,gCAAA;AChDF;;ADmDA;EACE,yBAlOkB;EAmOlB,WA3OY;AC2Ld;;ADkDA;EACE,yBAAA;AC/CF;;ADiDA;EACE,iBAAA;AC9CF;;ADgDA;;EAEE,6BAAA;AC7CF;;AD+CA;EACE,sBAxPY;AC4Md;AD8CE;EACE,yBAAA;EACA,eAAA;AC5CJ;;AD+CA;EACC,0CAAA;EACC,cA9Pe;ACkNjB;AD8CE;EACE,yCAAA;EACA,eAAA;AC5CJ;;ADgDA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC7CF;;AD+CA;EACE,yBAAA;EACA,0BAAA;AC5CF;;AD+CA;;CAAA;AAGA;EACE,sBAzRY;EA0RZ,yBAAA;EACA,qDAAA;AC5CF;;AD8CA;EACE,yBAtRkB;EAuRlB,yBAAA;EACA,eAAA;AC3CF;AD6CE;EACE,cAhSa;ACqPjB;;ADgDA;;CAAA;AAGA;EACE,yBA/SgB;ACkQlB;;ADgDA;EACE,yBAAA;EACA,yBAAA;AC7CF;;AD+CA;EACE,yBAAA;EACA,yBAAA;AC5CF;;AD+CA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AC5CF;;AD+CA;;CAAA;AAGA;EACE,sBAlUY;ACsRd;;AD+CA;EACE,yBA9TkB;ACkRpB;;ADgDA;;CAAA;AAGA;EACE,iGAAA;EACA,sBA/UY;ACkSd;;AD+CA;EACE,mBAAA;AC5CF;;AD8CA;EACE,mBAAA;AC3CF;;AD6CA;EACE,mBAAA;AC1CF;;AD4CA;EACE,gGAAA;EACA,sBA5VY;ACmTd;;AD2CA;EACE,gGAAA;EACA,yBAAA;ACxCF;;AD0CA;EACE,mBAAA;ACvCF;;AD0CA;EACE,gGAAA;EACA,sBAxWY;ACiUd;;ADyCA;EACE,gGAAA;EACA,yBAAA;ACtCF;;ADyCA;EACE,mBAAA;ACtCF;;ADyCA;EACE,gGAAA;EACA,sBArXY;AC+Ud;;ADwCA;EACE,gGAAA;EACA,yBAAA;ACrCF;;ADuCA;EACE,mBAAA;ACpCF;;ADuCA;;;;EAIE,WAnYY;AC+Vd;;ADuCA;;CAAA;AAGA;EACE,qCAAA;ACpCF;;ADuCA;EACE,cA3Ye;ACuWjB;;ADwCA;;CAAA;AAGA;EACE,sBAAA;ACrCF;;ADwCA;EACE,yBAAA;ACrCF;;ADwCA;EACE,yBAtaqB;EAuarB,WA/ZY;AC0Xd;;ADuCA;EACE,yBA1aqB;EA2arB,WAnaY;AC+Xd;;ADuCA;EACE,6BAAA;ACpCF;;ADuCA;EACE,2BAAA;ACpCF;;ADuCA;EACE,yBAvbqB;ACmZvB;;ADuCA;EACE,WAnbY;EAobZ,6BAAA;EACA,yBAAA;ACpCF;;ADuCA;EACE,yBAjcqB;AC6ZvB;;ADwCA;EACE,yBAzcgB;ACoalB;;ADwCA;EACE,eAAA;EACA,gBAzec;EA0ed,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,cAvec;EAwed,gBAAA;ACrCF;;ADuCA;;;EAGE,yBA7ec;EA8ed,WA9cY;AC0ad;;ADuCA;EACE,gBAAA;EACA,YAAA;EACA,WApdY;EAqdZ,yBA3eY;EA4eZ,YAAA;EACA,eAAA;EACA,gBA9fc;AC0dhB;;ADuCA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACpCF;;ADuCA;EACE,WAleY;EAmeZ,yBAzfY;EA0fZ,YAAA;ACpCF;;ADuCA;EACE,QAAA;ACpCF;;ADuCA;EACE,eAAA;EACF,eAAA;EACE,yBA7fW;EA8fX,WA/eY;EAgfZ,eAAA;EACA,gBAvhBc;EAwhBd,YAAA;ACpCF;;ADuCA;EACE,0BAAA;EACA,uBAAA;EACA,oCAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;EACA,iCAAA;ACpCF;;ADuCA;EACE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACpCF;;ADuCA;EACE,kBAAA;EACA,SAAA;ACpCF;;ADuCA;;;EAGE,oCAAA;EACA,WA/gBY;EAghBZ,YAAA;ACpCF;;ADuCA;EACE,yBApjBc;ACghBhB;;ADuCA;;;EAGE,yBA1jBc;ACshBhB;;ADuCA;EACE,MAAA;ACpCF;;ADwCA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;ACrCF;;ADwCA;EACE,aAAA;EACA,kBAAA;ACrCF;;ADwCA;EACE,mBAAA;ACrCF;;ADwCA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;ACrCF;;ADwCA;EACE,UAAA;ACrCF;;ADwCA;EACE,yBApkBqB;EAqkBrB,WA7jBY;ACwhBd;;ADwCA;EACE,UAjkBY;AC4hBd;;ADwCA;EACE,yBAhlBgB;AC2iBlB;;ADwCA;EACE,yBAAA;ACrCF;;ADwCA;EACE,6BAAA;EACA,yBAAA;EACA,WA/kBY;AC0iBd;;ADwCA;;EAEE,yBA5lBqB;EA6lBrB,WArlBY;ACgjBd;;ADuCA;EACE,6BAAA;EACA,yBAAA;EACA,WA1lBY;ACsjBd;;ADwCA;EACE;IACE,gBAAA;ECrCF;AACF;ADuCA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;ECrCF;AACF;ADuCA;EACE;IACE,uBAAA;ECrCF;AACF;ADuCA;EACE;IACE,uBAAA;ECrCF;EDuCA;IACE,6BAAA;ECrCF;AACF;ADuCA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,6BAAA;ECrCF;EDuCA;IACE,kBAAA;ECrCF;AACF;ADwCA;EACE;IACI,iBAAA;ECtCJ;EDwCA;IACI,gBAAA;ECtCJ;AACF;AAlpBA;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;AAopBJ;AAlpBQ;EACI,eAAA;EACA,mBAAA;AAopBZ;AAjpBQ;EACI,YAAA;EACA,yBAAA;EACA,kBAAA;AAmpBZ;AA/oBQ;EACI,YAAA;EACA,kBAAA;EACA,yBDwCO;ECvCP,aAAA;EACA,WDyBE;ECxBF,eAAA;EACA,gBAAA;AAipBZ;AA9oBY;EACI,2CDiCK;AC+mBrB;;AA3oBA;EACI;IACI,WAAA;EA8oBN;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');\n\nbody {\n  font-family: \"Urbanist\", sans-serif !important;\n}\n\n/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #205440;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #F3F4F8;\n$cardIcon2-bg: #FAF4FB;\n$cardIcon3-bg: #FAF7F3;\n$cardIcon4-bg: #F5F9FC;\n$cardIcon2-color: #AC44BB;\n$cardIcon3-color: #D69A5F;\n$cardIcon4-color: #176CA5;\n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #1e1e2d;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #205440;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 290px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: calc(100% - 320px);\n  position: relative;\n  left: 290px;\n  padding: 30px 30px 80px 30px;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: #F5F6FA;\n  overflow-y: auto;\n}\n.dashboardContain { \n  width: calc(100% - 320px);\n  background-Color:$mainBg;\n  border-radius: 8px;\n}\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard, \n.bodythemedark .cont2 { \n  background-Color: $darkTheme_darkBlue;\n}\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n.subLink svg {\n  position: relative;\n  top: -2px;\n  left: -7px;\n}\n\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 1; \n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span, .menulinklight:hover a { \n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark {\n  color: $lightthemetext !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n.tableheadlight th {\n  color: $white-color;\n}\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n} \nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child  {\n  border-radius: 0 5px 0px 0;\n}\nth:first-child {\n  border-radius: 0px;\n} \ntd:last-child {\n  border-radius: 0px;\n}\ntable.table.table-borderless{\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n.tablebodylight td, \n.tablebodydark td {\n  padding: 1rem 1rem !important;\n}\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: pointer;\n  }\n}\n.tablebodydark {\n /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: pointer;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: #151521;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n#card1bglight:hover {\n  background: #f7fffc;\n}\n#card1bgdark {\n  background: #392f28;\n}\n#card1bgdark:hover {\n  background: #f7fffc;\n}\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n#card2bglight:hover {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: #f7fffc;\n}\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n#card3bglight:hover {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: #f7fffc;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n#card4bglight:hover {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: #f7fffc;\n}\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a, #card1bgdark p,\n#card2bgdark a , #card2bgdark p,\n#card3bgdark a, #card3bgdark p,\n#card4bgdark a, #card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $darkTheme_updateBtn;\n  color: $white-color;\n}\n#addform.formthemedark .savebtn {\n  background-color: $darkTheme_updateBtn;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important; \n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $darkTheme_updateBtn;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $darkTheme_updateBtn;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $darkTheme_updateBtn;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border-radius: 5px;\n  background-color: transparent;\n  border: solid 1px $primary-color;\n  color:  $primary-color;\n  min-width: 113px;\n}\n.resetbtn:hover, \n.resetbtn:active, \n.resetbtn:focus {\n  background-color: $primary-color;\n  color: $white-color;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: auto;\npadding: 10px 0;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: auto !important;\n  height: 50px !important;\n  background-color: $primary-color !important;\n  color: $white-color !important;\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border: none !important;\n  padding: .375rem 1rem !important;\n}\n\n.deleteBtn:active, .deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important; \n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover, \n.deleteBtn:active, \n.deleteBtn:focus {\n  background-color: $primary-color !important;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color;\n}\n\n.confirmBtn:hover, \n.confirmBtn:active, \n.confirmBtn:focus {\n  background-color: $primary-color;\n}\n\n.confirmBtn svg {\n  top: 0;\n}\n\n\n.back_dlt{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.delPopContainer .modal-body {\n  padding: 25px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.arrowback svg{\n  fill: #000; \n}\n\n.bodythemedark .arrowback {\n  background-color: $darkTheme_updateBtn; \n  color: $white-color;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $white-color;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $lightthemetext !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $darkTheme_updateBtn;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral, \n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $darkTheme_updateBtn;\n  color: $white-color;\n}\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $darkTheme_updateBtn;\n  color: $white-color;\n}\n\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 100px;\n  }\n}\n@media only screen and (max-width: 1024px) { \n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 998px) { \n  #dashboardcont2{\n    height: auto !important;\n  }\n}\n@media only screen and (max-width: 767px) { \n  .sectionright{\n    float: unset !important;\n  }\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 20px 10px !important;\n  }\n  .bodythemelight, .bodythemedark {\n    padding-top: 165px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n      max-width: 1055px;\n  }\n  .delPopContainer .modal-dialog {\n      max-width: 350px;\n  }\n}","@import \"../../styles/Variables/Variables.scss\";\n\n#addform{\n    margin-top: 30px;\n    padding: 30px;\n    border-radius: 10px;\n\n        #addheading{\n            font-size: 16px;\n            margin-bottom: 20px;\n        }\n\n        .selectdate{\n            padding: 5px;\n            border: 1px solid #ced4da;\n            border-radius: 5px;\n        }\n\n        \n        .savebtn{\n            border: none;\n            border-radius: 5px;\n            background-color: $primary-btncolor;\n            padding: 10px;\n            color: $white-color;\n            font-size: 14px;\n            margin-top: 20px;\n             \n\n            &:hover{\n                background-color: $secondary-btncolor;\n            }\n        }\n}\n\n@media only screen and (max-width: 767px) {\n    .selectdate{\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `preferences_dashboard__tSBy1`,
	"dashboardContain": `preferences_dashboardContain__bDkZ5`,
	"bodythemedark": `preferences_bodythemedark__np6Ve`,
	"cont2": `preferences_cont2__depn9`,
	"top_header": `preferences_top_header__l7aPN`,
	"top_header_inner": `preferences_top_header_inner__Dth2I`,
	"subLink": `preferences_subLink__khKDa`,
	"footer": `preferences_footer__r04q2`,
	"bodythemelight": `preferences_bodythemelight__tHR-R`,
	"headerthemelight": `preferences_headerthemelight__Hco8q`,
	"headerthemedark": `preferences_headerthemedark__EFH3X`,
	"menuthemelight": `preferences_menuthemelight__FTSff`,
	"menuthemedark": `preferences_menuthemedark__Qijid`,
	"menulinklight": `preferences_menulinklight__3Lqd7`,
	"menulinkdarkSelected": `preferences_menulinkdarkSelected__zN0Tf`,
	"menulinklightSelected": `preferences_menulinklightSelected__reWhp`,
	"menulinkdark": `preferences_menulinkdark__YRAx+`,
	"headinglight": `preferences_headinglight__x4dYo`,
	"headingdark": `preferences_headingdark__RPbE2`,
	"searchboxlight": `preferences_searchboxlight__ijq4Y`,
	"searchboxdark": `preferences_searchboxdark__sEMKE`,
	"tableheadlight": `preferences_tableheadlight__XPJQ4`,
	"tableheaddark": `preferences_tableheaddark__+2rDh`,
	"table": `preferences_table__BP+02`,
	"table-borderless": `preferences_table-borderless__H7cIg`,
	"left-section": `preferences_left-section__6ls-q`,
	"tablebodylight": `preferences_tablebodylight__FAGxy`,
	"tablebodydark": `preferences_tablebodydark__JAnvR`,
	"paginationlight": `preferences_paginationlight__5Hjsu`,
	"paginationdark": `preferences_paginationdark__lu5oV`,
	"formthemelight": `preferences_formthemelight__q3vTO`,
	"formthemedark": `preferences_formthemedark__I1pqo`,
	"viewformlight": `preferences_viewformlight__4yKMt`,
	"permissionboxlight": `preferences_permissionboxlight__6lfep`,
	"permissionboxdark": `preferences_permissionboxdark__gGSCa`,
	"errormsgclr": `preferences_errormsgclr__zz3-Z`,
	"graphclrlight": `preferences_graphclrlight__IKRVf`,
	"graphclrdark": `preferences_graphclrdark__kBaaI`,
	"card1bglight": `preferences_card1bglight__tjy3Q`,
	"card1bgdark": `preferences_card1bgdark__bXNWZ`,
	"card2bglight": `preferences_card2bglight__5jhHk`,
	"card2bgdark": `preferences_card2bgdark__jXDR9`,
	"card3bglight": `preferences_card3bglight__33Qkg`,
	"card3bgdark": `preferences_card3bgdark__AryWb`,
	"card4bglight": `preferences_card4bglight__JHMsk`,
	"card4bgdark": `preferences_card4bgdark__eweA0`,
	"actionbtnlight": `preferences_actionbtnlight__HDnp3`,
	"actionbtndark": `preferences_actionbtndark__Ao-sf`,
	"profiledropdownlight": `preferences_profiledropdownlight__-DJRK`,
	"profiledropdowndark": `preferences_profiledropdowndark__Gx3xT`,
	"settingsection": `preferences_settingsection__w4Ex8`,
	"addform": `preferences_addform__oGG7x`,
	"savebtn": `preferences_savebtn__NIyFf`,
	"profile_conatiner": `preferences_profile_conatiner__4LKOk`,
	"ag-theme-alpine": `preferences_ag-theme-alpine__F37Wi`,
	"ag-row": `preferences_ag-row__BQWoB`,
	"formbtn": `preferences_formbtn__MYlvp`,
	"resetbtn": `preferences_resetbtn__GAT1d`,
	"addBtn": `preferences_addBtn__DeCdD`,
	"cust_addBtn": `preferences_cust_addBtn__7UZXY`,
	"deleteBtn": `preferences_deleteBtn__9qyD7`,
	"confirmBtn": `preferences_confirmBtn__JDTye`,
	"back_dlt": `preferences_back_dlt__S1L7r`,
	"delPopContainer": `preferences_delPopContainer__nLae-`,
	"modal-body": `preferences_modal-body__SNFZQ`,
	"delet_icon": `preferences_delet_icon__Gec+n`,
	"arrowback": `preferences_arrowback__drSNZ`,
	"drpdwn_btn": `preferences_drpdwn_btn__sEdF1`,
	"empname": `preferences_empname__-jOgz`,
	"navitemli": `preferences_navitemli__fGQU8`,
	"tabnavli": `preferences_tabnavli__H0hVT`,
	"settingsgeneral": `preferences_settingsgeneral__D3n6U`,
	"settingslinks": `preferences_settingslinks__1rthO`,
	"dashboardcont2": `preferences_dashboardcont2__lSw8P`,
	"sectionright": `preferences_sectionright__lDN5V`,
	"exer_modal_contain": `preferences_exer_modal_contain__lNxkM`,
	"modal-dialog": `preferences_modal-dialog__AU0YP`,
	"addheading": `preferences_addheading__v4xT9`,
	"selectdate": `preferences_selectdate__Qx0TG`
};
export default ___CSS_LOADER_EXPORT___;
